"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const SidebarNavigationItem_1 = __importDefault(require("../../molecules/buttons/SidebarNavigationItem"));
function SidebarNavigation({ items, renderItem: propRenderItem }) {
    const renderItem = propRenderItem ||
        ((item, index) => react_1.default.createElement(SidebarNavigationItem_1.default, Object.assign({}, item, { key: `${item.title}${item.href}` })));
    return (react_1.default.createElement("nav", { className: "flex-1 mt-5 px-2 dark:bg-black-800 bg-white space-y-1" }, items === null || items === void 0 ? void 0 : items.map((item, index) => renderItem({ ...item, renderItem }, index))));
}
exports.default = SidebarNavigation;
